import React from 'react';
import MainLayout from '../components/MainLayout';
import { CheckSquare } from 'lucide-react';

const ActionInbox = () => {
  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-semibold tracking-tight text-slate-900">
            <CheckSquare className="inline-block w-8 h-8 mr-2 mb-1" />
            Action Inbox
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            Review and approve pending items
          </p>
        </div>

        <div className="bg-white border border-slate-200 rounded-lg p-12 text-center">
          <CheckSquare className="w-16 h-16 mx-auto mb-4 text-slate-300" />
          <h3 className="text-lg font-medium text-slate-900 mb-2">No Pending Actions</h3>
          <p className="text-sm text-slate-600">
            You have no items pending for approval at this time.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default ActionInbox;
